import { RouterModule, Routes } from "@angular/router";
import { tabDirtyGuard } from "src/app/libs/components/tabs-host/tab-dirty.guard";
import { NgModule } from "@angular/core";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { UserSettingsComponent } from "./user-settings/user-settings.component";

const routes: Routes = [{
  path: '', children: [
    { path: 'profile', component: UserProfileComponent, canDeactivate: [tabDirtyGuard]  },
    { path: 'settings', component: UserSettingsComponent, canDeactivate: [tabDirtyGuard]  },
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }

